package com.wintermar.inspection.feature.presentation.inspection.answer.search

import androidx.lifecycle.viewModelScope
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import com.wintermar.inspection.feature.domain.service.ChunkUploadService
import com.wintermar.inspection.feature.domain.service.PendingUploadService
import com.wintermar.inspection.feature.domain.usecase.answer.SubmitAnswerUseCase
import com.wintermar.inspection.feature.domain.usecase.answer.UpsertAnswerUseCase
import com.wintermar.inspection.feature.domain.usecase.auth.GetUserUseCase
import com.wintermar.inspection.feature.domain.usecase.inspection.GetInspectionDetailUseCase
import com.wintermar.inspection.feature.domain.usecase.reference.GetListTemplateOptionUseCase
import com.wintermar.inspection.feature.domain.usecase.reference.GetListVesselUseCase
import com.wintermar.inspection.feature.presentation.inspection.answer.AnswerViewModel
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.receiveAsFlow

class InspectionSearchQuestionViewModel(
    inspectionTemplate: InspectionTemplateModel,
    getInspectionDetailUseCase: GetInspectionDetailUseCase,
    getListTemplateOptionUseCase: GetListTemplateOptionUseCase,
    getListVesselUseCase: GetListVesselUseCase,
    getUserUseCase: GetUserUseCase,
    upsertAnswerUseCase: UpsertAnswerUseCase,
    submitAnswerUseCase: SubmitAnswerUseCase,
    chunkUploadService: ChunkUploadService,
    pendingUploadService: PendingUploadService,
) : AnswerViewModel(
    inspectionId = inspectionTemplate.id,
    getInspectionDetailUseCase = getInspectionDetailUseCase,
    getListTemplateOptionUseCase = getListTemplateOptionUseCase,
    getListVesselUseCase = getListVesselUseCase,
    getUserUseCase = getUserUseCase,
    upsertAnswerUseCase = upsertAnswerUseCase,
    chunkUploadService = chunkUploadService,
    pendingUploadService = pendingUploadService,
    submitAnswerUseCase = submitAnswerUseCase
) {
    private val _navigationEvent = Channel<InspectionSearchQuestionEvent>()
    val navigationEvent = _navigationEvent.receiveAsFlow()

    override val state = InspectionSearchQuestionState(
        scope = viewModelScope,
        inspectionId = inspectionTemplate.id,
        onSaveAnswer = { answer, answerType, includeUploadFile ->
            processAnswer(answer, answerType, includeUploadFile)
        },
        onReattachUploadCallback = {
            reattachUploadCallbackResult()
        }
    )

    init {
        initAnswerData(skipDetail = true)
        state.template = inspectionTemplate
        state.onReattachUploadCallbackListener()
    }
}